import EventBus from '..'

export interface UiState {
  type?: 'alert' | 'confirm' | 'toast'
  title?: string
  msg?: string
  action?: any
  displayTime?: number
  additionalInfo?: { [key: string]: any }
}

export class UiEventBus extends EventBus<UiState> {
  name(): string {
    return 'uiEventBus'
  }
}

export default new UiEventBus()
